import { useEffect } from "react";
import { publishedReports } from "@/content/research/registry";
import { useSeo } from "@/lib/seo";
import { trackPage } from "@/lib/track";
import "@/styles/home.css";

const SITE = "https://99tests.com";

function Header() {
  return (
    <header className="site-header"><div className="wrap">
      <a className="logo" href="/"><i></i>99tests</a>
      <nav>
        <a href="/#how">How it works</a>
        <a href="/devices" data-testid="nav-devices">Devices</a>
        <a href="/pricing">Pricing</a>
        <a href="/research" data-testid="nav-research">Research</a>
        <a href="https://blog.99tests.com/" data-testid="nav-blog">Blog</a>
        <a className="btn sm blue" href="/pricing">Start a job</a>
      </nav>
    </div></header>
  );
}

function Footer() {
  return (
    <footer className="site-footer"><div className="wrap">
      <div>© 2026 99tests · Bengaluru</div>
      <div>
        <a href="/pricing">Pricing</a>
        <a href="/devices">Devices</a>
        <a href="/research" data-testid="footer-research">Research</a>
        <a href="/sample-report/">Sample report</a>
      </div>
      <div>
        <a href="/crowdsourced-testing">Crowdsourced testing</a>
        <a href="/">Home</a>
        <a href="/mcp-server" data-testid="footer-mcp">For AI agents (MCP)</a>
        <a href="mailto:hello@99tests.com">hello@99tests.com</a>
      </div>
    </div></footer>
  );
}

export default function Research() {
  const path = "/research";
  const reports = publishedReports();
  const jsonld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
      { "@type": "ListItem", position: 2, name: "Research", item: SITE + path },
    ],
  };
  useSeo({
    title: "App quality research for India",
    description: "Data-backed reports from 99tests on real-device app quality in India — figures journalists can cite, embed and link to.",
    path,
    jsonld,
  });
  useEffect(() => { trackPage(path); }, []);

  return (
    <>
      <Header />
      <main data-testid="research-hub">
        <section className="hero"><div className="wrap"><div>
          <div className="ref"><b>99tests Research</b></div>
          <h1>App quality, measured on <em>real Indian devices.</em></h1>
          <p className="lede">Reports built from real testers running real apps on the budget phones and networks most of India uses. Numbers you can cite, charts you can embed.</p>
          <p><a href="/research/app-quality" data-testid="research-app-quality-link">App quality by category →</a></p>
        </div></div></section>

        <section><div className="wrap">
            <div data-testid="research-list" style={{ display: "grid", gap: 18 }}>
              <a href="/research/india-app-quality-report-q4-2026" data-testid="research-card-india-app-quality-report-q4-2026"
                style={{ display: "block", border: "1px solid var(--line)", borderRadius: 12, padding: "20px 22px", textDecoration: "none", color: "inherit" }}>
                <div className="muted small">23 Oct 2026</div>
                <h2 style={{ margin: "6px 0 4px" }}>India App Quality Report — Q4 2026</h2>
                <p className="muted" style={{ margin: "0 0 8px" }}>What 2,961 Google Play reviews say about how India's most-used apps actually behave.</p>
                <p className="lede" style={{ margin: 0 }}>10.7% of storefront reviews describe an app malfunctioning — and money apps break nearly twice as often. Figures you can cite, charts you can embed.</p>
              </a>
              {reports.map((r) => (
                <a key={r.slug} href={`/research/${r.slug}`} data-testid={`research-card-${r.slug}`}
                  style={{ display: "block", border: "1px solid var(--line)", borderRadius: 12, padding: "20px 22px", textDecoration: "none", color: "inherit" }}>
                  <div className="muted small">{new Date(r.datePublished).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</div>
                  <h2 style={{ margin: "6px 0 4px" }}>{r.title}</h2>
                  <p className="muted" style={{ margin: "0 0 8px" }}>{r.subtitle}</p>
                  <p className="lede" style={{ margin: 0 }}>{r.summary}</p>
                </a>
              ))}
            </div>
        </div></section>
      </main>
      <Footer />
    </>
  );
}
